import { jsx as _jsx } from "react/jsx-runtime";
import { InputCheckbox } from "../../../../InputCheckbox";
export const BooleanFilter = (props) => {
    const { label, helperLabel, value, onChange, } = props;
    return (_jsx(InputCheckbox, { dataComponentName: "BooleanFilter", label: label, helperLabel: helperLabel, value: value, onChange: onChange }));
};
